import classnames from 'classnames';
import React, { useCallback } from 'react';
import { CheckboxList } from "./components/CheckboxList/CheckboxList.js";
import { useCheckboxDependencies } from "./components/CheckboxList/useCheckboxDependencies.js";
import { Controls } from "./components/Controls/Controls.js";
import styles from "./TransferList.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function TransferList({
  className,
  left,
  right,
  filter,
  titleLeft,
  titleRight,
  render,
  onChange,
  placeholder = 'Suchbegriff eingeben',
  maxHeight
}) {
  const {
    searchTerm: searchTermLeft,
    setSearchTerm: setSearchTermLeft,
    allElements: allElementsLeft,
    filteredElements: filteredElementsLeft,
    handleChange: handleChangeLeft
  } = useCheckboxDependencies(left, filter, 'left');
  const {
    searchTerm: searchTermRight,
    setSearchTerm: setSearchTermRight,
    allElements: allElementsRight,
    filteredElements: filteredElementsRight,
    handleChange: handleChangeRight
  } = useCheckboxDependencies(right, filter, 'right');
  const moveRight = useCallback(all => {
    onChange?.(left.filter(elementLeft => !allElementsLeft.filter(element => all || element.checked).some(element => element.element === elementLeft)), [...right, ...allElementsLeft.filter(element => all || element.checked).map(element => element.element)]);
  }, [allElementsLeft, left, onChange, right]);
  const moveLeft = useCallback(all => {
    onChange?.([...left, ...allElementsRight.filter(element => all || element.checked).map(element => element.element)], right.filter(elementRight => !allElementsRight.filter(element => all || element.checked).some(element => element.element === elementRight)));
  }, [allElementsRight, left, onChange, right]);
  const handleRightClick = useCallback(() => moveRight(), [moveRight]);
  const handleLeftClick = useCallback(() => moveLeft(), [moveLeft]);
  const handleAllRightCLick = useCallback(() => moveRight(true), [moveRight]);
  const handleAllLeftClick = useCallback(() => moveLeft(true), [moveLeft]);
  return /*#__PURE__*/_jsxs("div", {
    className: classnames(styles.transferList, className),
    style: maxHeight ? {
      maxHeight
    } : {},
    children: [/*#__PURE__*/_jsx(CheckboxList, {
      elements: filteredElementsLeft,
      title: titleLeft,
      render: render,
      onChange: handleChangeLeft,
      searchTerm: searchTermLeft,
      onSearchTermChange: setSearchTermLeft,
      placeholder: placeholder
    }), /*#__PURE__*/_jsx(Controls, {
      onRightClick: handleRightClick,
      onLeftClick: handleLeftClick,
      onAllRightClick: handleAllRightCLick,
      onAllLeftClick: handleAllLeftClick,
      className: styles.controls
    }), /*#__PURE__*/_jsx(CheckboxList, {
      elements: filteredElementsRight,
      title: titleRight,
      render: render,
      onChange: handleChangeRight,
      searchTerm: searchTermRight,
      onSearchTermChange: setSearchTermRight,
      placeholder: placeholder
    })]
  });
}